import { utcParse } from 'd3-time-format';
import { StatData } from 'src/helpers/graphs';

export function transformStatDataForGraph(data: StatData[]) {
  const correctDates = data.map((datum: StatData) => {
    const date = utcParse('%Y%m%d')(datum.date as any);

    return {
      date,
      count: datum.count,
    };
  });

  return correctDates;
}



// WEBPACK FOOTER //
// ./src/helpers/graphTransforms.ts